module.exports = __webpack_public_path__ + "img/9788996103127.de7965fb.jpg";